import { BaseInfoType, StoreDetailInfoType } from '@kinderlabs-pos/shared-data-type';

import { posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const getStoreInfoDetailAsync =
	(rootUrl: string) =>
	async ({ storeId }: { storeId: number }) =>
		(
			await posAxiosClient.get<StoreDetailInfoType & BaseInfoType>(`${rootUrl}/store/detail`, {
				params: {
					id: storeId,
				},
			})
		).data;
